import { ReducersTypes } from "constants/ReducersTypes";

const initialCollectorInboxAIFilter = {
  status: "All",
  riskLevel: "All",
  source: null,
  category: "All",
  sortBy: "created_at",
  sortOrder: "desc",
};
// Metadata returned by the API. Never used as a useEffect dependency.
const initialCollectorInboxAIPagination = {
  nextNum: 2,
  prevNum: null,
  pages: 1,
  page: 1,
  limit: 20,
  total: 0,
};

const initialEmailIntegrationAIState = {
  loading: false,
  unreadCount: 0,
  threads: [],
  filters: { ...initialCollectorInboxAIFilter },
  pagination: { ...initialCollectorInboxAIPagination },
};

const emailIntegrationAIState = (
  state = initialEmailIntegrationAIState,
  action
) => {
  switch (action.type) {
    case ReducersTypes["SET_COLLECTOR_INBOX_LIST"]:
      return {
        ...state,
        threads: action.payload,
      };
    case ReducersTypes["SET_COLLECTOR_INBOX_PAGINATION"]:
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload },
      };
    case ReducersTypes["SET_COLLECTOR_INBOX_FILTERS"]:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
      };
    case ReducersTypes["SET_COLLECTOR_INBOX_LOADING"]:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default emailIntegrationAIState;
